import React from 'react'
import styled from 'styled-components'
import homeImg from '../assets/homeImg.jpg'

const Section = styled.div`
width: 100vw;
height: calc(100vh - 5rem);
position: relative;
/* background-color: black; */
/* color: white; */
`

const Title = styled.div`
width: 40%;
position: absolute;
top: 20vh;
right: 10vw;

span{
  font-size: 2rem;
  font-weight: 600;
}
`

const Subtext = styled.div`

`

const Home = () => {
  return (
    <Section>
    <img src={homeImg} alt="homeimg" />
    <Title>
     <span>In India,</span> students face a lot of trouble due to college schedule and academics as they are doing/learning a lot of side hustle like coding etc etc .... <br /> <br />
     But don't worry, StudUp is here for u😃😃 <br /> <br />
     Using <span>StudUp</span> u can keep a track of your academic performance, college attendance (as its a big issue 😩😩), look for courses, Notes and can chat with other folks.. 
     </Title>
    </Section>
  )
}

export default Home